module.exports = __webpack_public_path__ + "static/img/zl_btn1.a996b63.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/zl_btn1.png
// module id = OQpT
// module chunks = 7